import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "contentsTokenProps", "headerTokenProps", "onOpenChange", "open", "titleText", "useOnDark", "withContentPadding"];
import { Component } from 'react';
import styled from 'foundations-theming/utils';
import { Controllable } from 'foundations-components/transitional/components/Controllable';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { ExpandableContents } from 'foundations-components/transitional/components/ExpandableContents';
import { FieldGroupWrapper, getHoverCssStyles } from 'ContentComponents/components/cmv2/components/FieldGroupWrapper';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { makeSpacedComponent } from 'ContentComponents/components/cmv2/components/SpacedComponent';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';

/*
Customization of ExpandableSection - moved the caret to the right side and
removed most of the overrideable props
*/
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeaderWrapper = styled.div.withConfig({
  displayName: "ExpandableSection__HeaderWrapper",
  componentId: "sc-1veyreq-0"
})(({
  theme
}) => {
  return getHoverCssStyles(theme);
});
const ExpandableCaretWrapper = makeSpacedComponent('div', ({
  open
}) => {
  return {
    transition: 'all 150ms ease-in-out',
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
  };
});
const getContentsStyleProps = ({
  open,
  useOnDark
}) => {
  const borderProps = open ? {
    borderBlockStartColor: 'border-core-default',
    borderBlockStartStyle: 'solid',
    borderBlockStartWidth: '100'
  } : {};
  const backgroundColor = useOnDark ? 'fill-tertiary-default' : 'fill-tertiary-hover';
  return Object.assign({
    backgroundColor
  }, borderProps);
};
class ExpandableSection extends Component {
  constructor(props) {
    super(props);
    this.displayName = 'ExpandableSection';
    this.onClick = this.onClick.bind(this);
  }
  onClick() {
    const {
      onOpenChange,
      open
    } = this.props;
    onOpenChange(SyntheticEvent(!open));
  }
  render() {
    const _this$props = this.props,
      {
        children,
        contentsTokenProps,
        headerTokenProps,
        open,
        titleText,
        useOnDark,
        withContentPadding
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const dataOpen = open ? 'true' : 'false';
    return /*#__PURE__*/_jsxs(FieldGroupWrapper, Object.assign({
      "data-open": dataOpen
    }, rest, {
      children: [/*#__PURE__*/_jsx(HeaderWrapper, {
        children: /*#__PURE__*/_jsx(Clickable, {
          "aria-expanded": dataOpen,
          onClick: this.onClick,
          children: /*#__PURE__*/_jsx(View, Object.assign({
            "data-open": dataOpen,
            paddingInline: "600",
            paddingBlock: "500"
          }, headerTokenProps, {
            children: titleText ? /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              justifyContent: "space-between",
              children: [/*#__PURE__*/_jsx(Text, {
                as: "h6",
                marginBlock: "0",
                role: "presentation",
                truncate: true,
                children: titleText
              }), /*#__PURE__*/_jsx(ExpandableCaretWrapper, {
                marginInlineStart: "300",
                open: open,
                children: /*#__PURE__*/_jsx(Flex, {
                  children: /*#__PURE__*/_jsx(IconHolder, {
                    color: "icon-interactive-default",
                    icon: DownIcon,
                    size: "200",
                    padding: "0"
                  })
                })
              })]
            }) : null
          }))
        })
      }), children ? /*#__PURE__*/_jsx(AccordionTransition, {
        open: open,
        children: /*#__PURE__*/_jsx(View, Object.assign({}, getContentsStyleProps({
          open,
          useOnDark
        }), {
          paddingInline: withContentPadding ? '500' : '0'
        }, contentsTokenProps, {
          children: /*#__PURE__*/_jsx(ExpandableContents, {
            "aria-hidden": open ? 'false' : 'true',
            "data-test-id": "expandable-section-contents",
            indentation: "none",
            open: open,
            children: children
          })
        }))
      }) : null]
    }));
  }
}
ExpandableSection.defaultProps = {
  open: false
};
export default Controllable(ExpandableSection, ['open']);